<template>
    <div class="topbar" :class="isMobile ? 'pl-20 pr-10' : ' '">
      <div class="container pr-0 pl-0 pt-0" style="display: flex;justify-content: space-between">
        <div class="topbar-column" :style="isMobile ? 'width: 10%' : 'width: 30%'">
          <template v-if="!isMobile">
            <a class="" :href="'mailto:' + config.help_mail" v-if="config.help_mail">
              <i class="fa fa-envelope-o" aria-hidden="true"></i>&nbsp; <template v-if="!isMobile">{{ config.help_mail }}</template>
            </a>
            <a class="pl-5" :href="'tel:' + config.phone" v-if="config.phone">
              <i class="fa fa-phone" aria-hidden="true"></i>&nbsp;<template v-if="!isMobile">{{ config.phone }}</template>
            </a>
            <a class="social-button sb-facebook shape-none sb-dark pl-5" href="https://www.facebook.com/Okubuy-525247421235846" target="_blank">
              <i class="fa fa-facebook-official" aria-hidden="true"></i>
            </a>
            <!--
            <a class="social-button sb-twitter shape-none sb-dark" href="javascript:void(0);" target="_blank">
                <i class="fa fa-twitter" aria-hidden="true"></i>
            </a>
            <a class="social-button sb-instagram shape-none sb-dark" href="javascript:void(0);" target="_blank">
                <i class="fa fa-instagram" aria-hidden="true"></i>
            </a>
            -->
          </template>
        </div>
        <div class="topbar-column" style="width: 75%;">
          <template v-if="!isMobile">
            <span class="ml-0" style="line-height: 1">
              <template v-if="isLogined && user">
                [<a href="/logout" @click.prevent="logout()">
                  {{ $t('user.logout') }}
                </a>]
              </template>
              <template v-else>
                [<router-link :to="{ name: 'register' }">
                  {{ $t('app.register')}}
                </router-link>]
              </template>
            <!--</template>-->
          </span>
            <router-link :to="{ name: 'faq' }" class="hidden-md-down">
              <i class="fa fa-question-circle" aria-hidden="true"></i>
              {{ $t('topbar.faq') }}
            </router-link>
            <router-link :to="{ name: 'guide' }" class="hidden-md-down">
              <i class="fa fa-book" aria-hidden="true"></i>
              {{ $t('topbar.guide') }}
            </router-link>
          </template>

          <language-switcher />
          <region-switcher />
          <!--<currency-switcher class="ml-0" />-->
        </div>
      </div>

    </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex';
  import LanguageSwitcher from './LanguageSwitcher.vue';
  import RegionSwitcher from './RegionSwitcher.vue';
  import CurrencySwitcher from './CurrencySwitcher.vue';

  export default {
    name: 'TopBar',
    computed: {
      ...mapState({
        config: state => state.config,
        user: state => state.user.identity,
      }),
      ...mapGetters([
        'isLogined',
        'isMobile',
      ]),
    },
    components: {
      LanguageSwitcher,
      RegionSwitcher,
      CurrencySwitcher,
    },
    methods: {
      logout() {
        this.$store.dispatch('logout')
          .then(() => {
            if (this.$route.meta.needAuthenticate) {
              this.$router.push({ name: 'home' });
            }
        });
      },
    },
  };
</script>

<style lang="scss">

    @import "../.././styles/helpers/variables";
    .user-overflow {
      max-width: 90px;
      display: inline-block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .topbar {
        display: table;
        position: relative;
        width: 100%;
        height: 35px;
        padding: 0 30px;
        border-bottom: 1px solid $border-color;
        background-color: $gray-lighter;
        z-index: 9010;
      .container {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        .cancas{
          height: 100%;
          ul {
            height: 100%;
            border: none;
            background-color: initial;
            li {
              height: 100%;
              .el-submenu__title {
                height: 100%;
                line-height: 35px;
                border: none;
              }
              .el-submenu__title:hover{
                background-color: #dcdcdc;
              }
            }
          }
        }
        .topbar-column {
          display: table-cell;
          vertical-align: middle;
          &:last-child { text-align: right; }
          &:first-child { text-align: left; }
          a:not(.social-button), span, p {
            color: $nav-link-color;
            font-size: $font-size-xs;
          }
          > a:not(.social-button), > span, > p {
            display: inline-block;
            margin: {
              top: 5px;
              bottom: 5px;
            }
            > i { margin-top: -3px; }
            > i.icon-download { margin-top: -4px; }
          }
          a:not(.social-button) {
            transition: color .3s;
            text-decoration: none;
            &:hover { color: $nav-link-hover-color; }
          }
        }
        .topbar-column:last-child {
          > a:not(.social-button), > span, > p {
            margin-left: 10px;
          }
        }
        .topbar-column:first-child {
          > a:not(.social-button), > span, > p {
            margin-right: 10px;
          }
        }
      }
      }
    .clear-dropdown {
      padding-right: 0px !important;
      margin-left: 0px !important;
    }
      @media (max-width: 765px) {
        .topbar-column:first-child {
          > a:not(.social-button), > span, > p {
            margin-right: 7px !important;
          }
        }
      }
</style>
